export default __webpack_public_path__ + "static/media/milestone 750.bfcebeb4.svg";